import React, { Component } from 'react';

class BendTimePopup extends Component {
    createMinuteSelectItems() {
        let items = [];
        for (let i = 1; i <= 59; i++) {
            items.push(<option key={i} value={i}>{i}</option>);
        }
        return items;
    }

    render() {
        return (
            <div>
                <div className="popup-option" style={this.props.showTimerInput ? {} : { display: 'none' }}>
                    <div className="popup-container">
                        <div>
                            <div className="col">
                                <label>Set Timer</label>
                            </div>
                            <div className="col">
                                <select key={`selectTimerMinute-${this.props.startTimerMinutes}`} defaultValue={this.props.startTimerMinutes} onChange={this.props.timerStartChanged} >
                                    {this.createMinuteSelectItems()}
                                </select>
                            </div>
                        </div>
                        <div>
                            <div className="col">
                                <button onClick={this.props.clearTimer}>Clear</button>
                            </div>
                            <div className="col">
                                <button onClick={this.props.showTimer}>Set</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default BendTimePopup;